export default "__VITE_PUBLIC_ASSET__80f467cc__"